import { Box, CircularProgress, Tab, Tabs } from '@mui/material';
import { AppConfig } from 'AppConfig';
import { fetchData, waitForTenantSwitch } from 'features/user/userActions';
import * as UserTypes from 'features/user/userTypes';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { tabNoUnderlineSx, tabsNoUnderlineSx } from 'common/tabSx';
import { store } from 'store/store';

const LookupTableNav = () => {
  const location = useLocation();
  const [currentTab, updateCurrentTab] = useState(AppConfig.LOOKUP_TABLES_SUB_URL.LOOKUP);

  const currentApp = useSelector((state) => state.user.currentApp);
  const currentTenantCd = useSelector((state) => state.user.currentTenantCd);

  useEffect(() => {
    store.dispatch({
      type: UserTypes.APP_SWITCHED,
      payload: AppConfig.HEADER_MENU_TYPE.NONE
    });
    const tab = location.pathname.split('/').slice(-1).pop();
    tab === AppConfig.MASTER_DATA_SUB_URL.MASTER_TABLE
      ? updateCurrentTab(AppConfig.LOOKUP_TABLES_SUB_URL.LOOKUP)
      : updateCurrentTab(tab);
  }, [location]);

  useEffect(() => {
    if (!currentTenantCd || currentApp === AppConfig.APP_CODE_MASTER_DATA) {
      return;
    } // IAM uses the tenant to resolve the user’s access in the app. So currentTenantCd is required for the authentication-context switch, not for filtering Lookup data.

    let cancelled = false;

    // Wait out a switch already in flight and re-read the store so this doesn't
    // dispatch a competing switch for a tenant that's about to be superseded.
    (async () => {
      await waitForTenantSwitch();
      if (cancelled) return;

      const { currentTenantCd: latestTenant, currentApp: latestApp } = store.getState().user;
      if (!latestTenant || latestApp === AppConfig.APP_CODE_MASTER_DATA) {
        return;
      }

      store.dispatch(fetchData(latestTenant, AppConfig.APP_CODE_MASTER_DATA, { explicitTenant: false }));
    })();

    return () => {
      cancelled = true;
    };
  }, [currentApp, currentTenantCd]);

  if (currentApp !== AppConfig.APP_CODE_MASTER_DATA) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 6 }}>
        <CircularProgress aria-label="Loading lookup data" />
      </Box>
    );
  }

  return (
    <>
      <Tabs
        value={currentTab}
        indicatorColor="primary"
        textColor="primary"
        sx={tabsNoUnderlineSx}
        variant="scrollable">
        <Tab
          label="Expense Name"
          value={AppConfig.LOOKUP_TABLES_SUB_URL.LOOKUP}
          component={Link}
          to={AppConfig.LOOKUP_TABLES_SUB_URL.LOOKUP}
          sx={tabNoUnderlineSx}
        />
        <Tab
          label="Election Tier"
          value={AppConfig.LOOKUP_TABLES_SUB_URL.ELECTION_TIER_LIST}
          component={Link}
          to={AppConfig.LOOKUP_TABLES_SUB_URL.ELECTION_TIER_LIST}
          sx={tabNoUnderlineSx}
        />
      </Tabs>
      <Outlet />
    </>
  );
};

export default LookupTableNav;
